// extracted by mini-css-extract-plugin
module.exports = {"menuPaper":"MoreOptionsButton_menuPaper__cdyu1"};